import moment from 'moment';
const company = '1958_HK_Equity';
const company6 = '1114_HK_Equity'; //

export const labelsDefault = {
    attributeNames:
        'sharePriceInfo.targetPrice,sharePriceInfo.returnPer,sharePriceInfo.sharePrice,sharePriceInfo.targetPriceRange,sharePriceInfo.marketCap',
};
export const sharePriceDefault = {
    attributeNames:
        'targetPrice,returnPer,sharePrice,targetPriceRangeLow,targetPriceRangeHigh,marketCap,sharePriceIncPer,sharePriceIncValue,sharePriceCurr,marketCapCurr,dbsRcmd',
};
export const signalsDefault = {
    entityType: 'Company',
    signalCategory: 'Capital Market Performance',
};
export const financialDataDefault = {
    startYear: new Date().getFullYear() - 3,
    endYear: new Date().getFullYear() + 2,
};
export const criticalDataDefault = {
    companyId: company6,
};
export const stockConsensusData = {
    startDate: moment().subtract(1, 'y').subtract(1, 'd').format('YYYY-MM-DD'),
    endDate: moment().subtract(1, 'd').format('YYYY-MM-DD'),
};

export const graphMetaData = {
    userId: 'DBS',
};
export const companyListData = {
    companyId:
        '175_HK_Equity,1211_HK_Equity,2238_HK_Equity,489_HK_Equity,1114_HK_Equity,1958_HK_Equity,881_HK_Equity,425_HK_Equity,1316_HK_Equity,700_HK_Equity',
};

export const signalNamesForEntity = {
    companyId: '601939_CH_Equity',
    entityType: 'Company',
    entityId: 'TR4295863663',
    startDate: '2019-01-01',
    endDate: '2019-05-10',
    newsCount: 10,
};

export const shareRatioData = {
    companyId: company,
};
